import { MARKETTINGTOOLS__MUTATIONS } from "../mutation-types";
import { MARKETTINGTOOLS__ACTIONS } from '../action-types'
import { MARKETTINGTOOLS__API } from '@/_helpers/urls'
import http from "@/_helpers/http";
import toast from "@/services/Notification";

// State
const state = {
    bannerCategories: [],
    bannerSizes: [],
    banners: []
};

// Mutations
const mutations = {
    [MARKETTINGTOOLS__MUTATIONS.BANNERCATEGORIES](state, data) {
        state.bannerCategories = data
    },
    [MARKETTINGTOOLS__MUTATIONS.BANNERSIZES](state, data) {
        state.bannerSizes = data
    },
    [MARKETTINGTOOLS__MUTATIONS.BANNERS](state, data) {
        state.banners = data
    },
};

const getters = {};

// Actions
const actions = {
    async [MARKETTINGTOOLS__ACTIONS.BANNERCATEGORIES]({ commit }) {
        try {
            const response = await http().get(MARKETTINGTOOLS__API.BANNERCATEGORIES);
            const responseData = response.data?.data?.bannerCategories;
            commit(MARKETTINGTOOLS__MUTATIONS.BANNERCATEGORIES, responseData);
        } catch (error) {
            console.error("Error fetching partner profile:", error);
        }
    },

    async [MARKETTINGTOOLS__ACTIONS.BANNERSIZES]({ commit }) {
        try {
            const response = await http().get(MARKETTINGTOOLS__API.BANNERSIZES);
            const responseData = response.data?.data?.bannerSizes;
            commit(MARKETTINGTOOLS__MUTATIONS.BANNERSIZES, responseData);
        } catch (error) {
            console.error("Error fetching partner profile:", error);
        }
    },

    async [MARKETTINGTOOLS__ACTIONS.BANNERS]({ commit }) {
        try {
            const response = await http().get(MARKETTINGTOOLS__API.BANNERS);
            const responseData = response.data?.data?.banners;
            commit(MARKETTINGTOOLS__MUTATIONS.BANNERS, responseData);
        } catch (error) {
            console.error("Error fetching partner profile:", error);
        }
    },

    async [MARKETTINGTOOLS__ACTIONS.CREATEBANNER]({ dispatch }, parameter) {
        try {
            const response = await http().post(MARKETTINGTOOLS__API.CREATEBANNER, parameter);
            dispatch(MARKETTINGTOOLS__ACTIONS.BANNERS)
            toast.success(response?.data?.message)
        } catch (error) {
            console.error("Error fetching partner profile:", error);
        }
    },

    async [MARKETTINGTOOLS__ACTIONS.UPDATEBANNER]({ dispatch }, parameter) {
        try {
            const response = await http().post(MARKETTINGTOOLS__API.UPDATEBANNER, parameter);
            dispatch(MARKETTINGTOOLS__ACTIONS.BANNERS)
            toast.success(response?.data?.message)
        } catch (error) {
            console.error(error);
        }
    },

    async [MARKETTINGTOOLS__ACTIONS.DELETEBANNER]({ dispatch }, parameter) {
        try {
            const response = await http().delete(`${MARKETTINGTOOLS__API.DELETEBANNER}/${parameter?.id}`);
            dispatch(MARKETTINGTOOLS__ACTIONS.BANNERS)
            toast.success(response?.data?.message)
        } catch (error) {
            console.error(error);
        }
    },

    async [MARKETTINGTOOLS__ACTIONS.BANNERSIZECREATE]({ dispatch }, parameter) {
        try {
            const response = await http().post(MARKETTINGTOOLS__API.BANNERSIZECREATE, parameter);
            dispatch(MARKETTINGTOOLS__ACTIONS.BANNERSIZES)
            toast.success(response?.data?.message)
        } catch (error) {
            console.error(error);
        }
    },

    async [MARKETTINGTOOLS__ACTIONS.BANNERSIZEUPDATE]({ dispatch }, parameter) {
        try {
            const response = await http().post(MARKETTINGTOOLS__API.BANNERSIZEUPDATE, parameter);
            dispatch(MARKETTINGTOOLS__ACTIONS.BANNERSIZES)
            toast.success(response?.data?.message)
        } catch (error) {
            console.error(error);
        }
    },

    async [MARKETTINGTOOLS__ACTIONS.BANNERSIZEDELETE]({ dispatch }, parameter) {
        try {
            const response = await http().delete(`${MARKETTINGTOOLS__API.BANNERSIZEDELETE}/${parameter?.id}`);
            dispatch(MARKETTINGTOOLS__ACTIONS.BANNERSIZES)
            toast.success(response?.data?.message)
        } catch (error) {
            console.error(error);
        }
    }
};

export default {
    strict: process.env.NODE_ENV !== "production",
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
